
import Root from "../pages/Root";
import { Suspense } from 'react';
import MainPage from "../pages/MainPage";
import {withLoggedIn} from "./withLogginIn";
import {CartPageLazy, FavouritePageLazy, HistoryPageLazy,DocumentPageLazy,AdvanceSearchPageLazy} from "../pages/LazyPages";
import Loader from "../components/loader/loader";

const UserFavouritePageFinal = withLoggedIn(FavouritePageLazy);
const CartPageFinal = withLoggedIn(CartPageLazy);
const UserHistoryPageFinal = withLoggedIn(HistoryPageLazy);

export const routes = [
    {
        path: "/",
        element: <Root />,
        children: [
            {
                index: true,
                //loader: homeLoader,
                element: <MainPage />,
            },
            {
                path: 'document/:id_type',
                element: <Suspense fallback={<Loader/>}><DocumentPageLazy /></Suspense>
            },
            {
                path:"advance-search",
                element: <Suspense fallback={<Loader/>}><AdvanceSearchPageLazy /></Suspense>
            },
            {
                path: "cart",
                element: <Suspense fallback={<Loader/>}><CartPageFinal/></Suspense>
            },
            {
                path: "favourite",
                element: <Suspense fallback={<Loader/>}><UserFavouritePageFinal/></Suspense>
            },
            {
                path: "history",
                element: <Suspense fallback={<Loader/>}><UserHistoryPageFinal/></Suspense>
            }

        ],
    }
];
